const initials = "cadre/";

export const UPDATE_CADRE_LIST = `${initials}UPDATE_CADRE_LIST`;